// extracted by mini-css-extract-plugin
export default {"stockTable":"Stock_stockTable__7vNv7","stockContainer":"Stock_stockContainer__GkyUm","inlineLoader":"Stock_inlineLoader__Tj5+3","editorContainer":"Stock_editorContainer__5NSPw"};